/** Labels & options — formulaire devis multi-étapes */
const languages = {
  fr: [
    { id: 'fr', label: 'Français' },
    { id: 'ar', label: 'Arabe' },
    { id: 'en', label: 'Anglais' },
    { id: 'de', label: 'Allemand' },
    { id: 'es', label: 'Espagnol' },
    { id: 'it', label: 'Italien' },
    { id: 'pt', label: 'Portugais' },
    { id: 'tr', label: 'Turc' },
    { id: 'ru', label: 'Russe' },
    { id: 'zh', label: 'Chinois' },
    { id: 'other', label: 'Autre' },
  ],
  ar: [
    { id: 'fr', label: 'الفرنسية' },
    { id: 'ar', label: 'العربية' },
    { id: 'en', label: 'الإنجليزية' },
    { id: 'de', label: 'الألمانية' },
    { id: 'es', label: 'الإسبانية' },
    { id: 'it', label: 'الإيطالية' },
    { id: 'pt', label: 'البرتغالية' },
    { id: 'tr', label: 'التركية' },
    { id: 'ru', label: 'الروسية' },
    { id: 'zh', label: 'الصينية' },
    { id: 'other', label: 'أخرى' },
  ],
  en: [
    { id: 'fr', label: 'French' },
    { id: 'ar', label: 'Arabic' },
    { id: 'en', label: 'English' },
    { id: 'de', label: 'German' },
    { id: 'es', label: 'Spanish' },
    { id: 'it', label: 'Italian' },
    { id: 'pt', label: 'Portuguese' },
    { id: 'tr', label: 'Turkish' },
    { id: 'ru', label: 'Russian' },
    { id: 'zh', label: 'Chinese' },
    { id: 'other', label: 'Other' },
  ],
};

function build(lang) {
  const L = languages[lang];
  const isFr = lang === 'fr';
  const isAr = lang === 'ar';

  return {
    title: isFr ? 'Demande de devis' : isAr ? 'طلب عرض أسعار' : 'Quote request',
    subtitle: isFr
      ? 'Décrivez votre projet en quelques étapes — réponse personnalisée sous 60 minutes ouvrées.'
      : isAr
        ? 'صفوا مشروعكم في بضع خطوات — رد مخصص خلال 60 دقيقة عمل.'
        : 'Describe your project in a few steps — personalized reply within 60 business minutes.',
    steps: isFr
      ? ['Client', 'Service', 'Langues', 'Projet', 'Livraison', 'Commentaires', 'Validation']
      : isAr
        ? ['العميل', 'الخدمة', 'اللغات', 'المشروع', 'التسليم', 'ملاحظات', 'تأكيد']
        : ['Client', 'Service', 'Languages', 'Project', 'Delivery', 'Comments', 'Confirm'],
    next: isFr ? 'Suivant' : isAr ? 'التالي' : 'Next',
    prev: isFr ? 'Précédent' : isAr ? 'السابق' : 'Previous',
    submit: isFr ? 'Demander un devis' : isAr ? 'اطلب عرض أسعار' : 'Request a quote',
    submitting: isFr ? 'Envoi en cours…' : isAr ? 'جارٍ الإرسال…' : 'Sending…',
    submitError: isFr
      ? 'La demande n’a pas pu être envoyée. Vérifiez que le serveur WAMP est démarré, puis réessayez.'
      : isAr
        ? 'تعذر إرسال الطلب. تحققوا من تشغيل خادم WAMP ثم حاولوا مجدداً.'
        : 'The request could not be sent. Check that the WAMP server is running, then try again.',
    required: isFr ? 'Champ obligatoire' : isAr ? 'حقل إلزامي' : 'Required field',
    optional: isFr ? '(optionnel)' : isAr ? '(اختياري)' : '(optional)',
    addLanguage: isFr ? 'Ajouter une combinaison' : isAr ? 'إضافة تركيبة' : 'Add language pair',
    remove: isFr ? 'Supprimer' : isAr ? 'حذف' : 'Remove',
    addFiles: isFr ? 'Ajouter des fichiers' : isAr ? 'إضافة ملفات' : 'Add files',
    filesHint: isFr
      ? 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, ZIP…'
      : isAr
        ? 'PDF، DOC، DOCX، XLS، XLSX، PPT، PPTX، JPG، PNG، ZIP…'
        : 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, ZIP…',
    successTitle: isFr ? 'Merci pour votre demande.' : isAr ? 'شكراً لطلبكم.' : 'Thank you for your request.',
    successText: isFr
      ? 'Votre demande de devis a été enregistrée avec succès. Notre équipe analysera votre projet et vous adressera une proposition tarifaire personnalisée dans les meilleurs délais.'
      : isAr
        ? 'تم تسجيل طلب عرض الأسعار بنجاح. سيحلل فريقنا مشروعكم ويرسل لكم عرضاً مخصصاً في أقرب وقت.'
        : 'Your quote request has been saved successfully. Our team will review your project and send a personalized proposal as soon as possible.',
    successEmail: isFr
      ? 'Un e-mail de confirmation vous sera envoyé à l\'adresse indiquée.'
      : isAr
        ? 'سيُرسل إليكم بريد تأكيد على العنوان المذكور.'
        : 'A confirmation email will be sent to the address you provided.',
    successRef: isFr ? 'Numéro de demande' : isAr ? 'رقم الطلب' : 'Request number',
    backHome: isFr ? 'Retour à l\'accueil' : isAr ? 'العودة للرئيسية' : 'Back to home',
    newRequest: isFr ? 'Nouvelle demande' : isAr ? 'طلب جديد' : 'New request',

    // Step 1
    step1Title: isFr ? 'Informations du client' : isAr ? 'معلومات العميل' : 'Client information',
    civility: isFr ? 'Civilité' : isAr ? 'الصفة' : 'Title',
    civilities: {
      'M.': isFr ? 'M.' : isAr ? 'السيد' : 'Mr',
      'Mme': isFr ? 'Mme' : isAr ? 'السيدة' : 'Mrs',
      'Mlle': isFr ? 'Mlle' : isAr ? 'الآنسة' : 'Ms',
    },
    lastName: isFr ? 'Nom' : isAr ? 'اللقب' : 'Last name',
    firstName: isFr ? 'Prénom' : isAr ? 'الاسم' : 'First name',
    company: isFr ? 'Entreprise / Organisation' : isAr ? 'الشركة / المنظمة' : 'Company / Organization',
    jobTitle: isFr ? 'Fonction' : isAr ? 'الوظيفة' : 'Job title',
    email: 'E-mail',
    phone: isFr ? 'Téléphone' : isAr ? 'الهاتف' : 'Phone',
    country: isFr ? 'Pays' : isAr ? 'البلد' : 'Country',
    city: isFr ? 'Ville' : isAr ? 'المدينة' : 'City',

    // Step 2
    step2Title: isFr ? 'Sélection du service' : isAr ? 'اختيار الخدمة' : 'Service selection',
    category: isFr ? 'Catégorie' : isAr ? 'الفئة' : 'Category',
    catTranslation: isFr ? 'Traduction' : isAr ? 'ترجمة' : 'Translation',
    catInterpreting: isFr ? 'Interprétariat' : isAr ? 'ترجمة فورية' : 'Interpreting',
    translationService: isFr ? 'Service demandé' : isAr ? 'الخدمة المطلوبة' : 'Requested service',
    interpretingType: isFr ? 'Type d\'interprétation' : isAr ? 'نوع الترجمة الفورية' : 'Interpreting type',
    groupOfficial: isFr ? 'Traduction officielle' : isAr ? 'ترجمة رسمية' : 'Official translation',
    groupSpecialized: isFr ? 'Traductions spécialisées' : isAr ? 'ترجمات متخصصة' : 'Specialized translation',
    groupDigital: isFr ? 'Traduction digitale' : isAr ? 'ترجمة رقمية' : 'Digital translation',
    translationServices: {
      sworn: isFr ? 'Traduction assermentée' : isAr ? 'ترجمة محلّفة' : 'Sworn translation',
      certified: isFr ? 'Traduction certifiée' : isAr ? 'ترجمة مصادق عليها' : 'Certified translation',
      legal: isFr ? 'Traduction juridique' : isAr ? 'ترجمة قانونية' : 'Legal translation',
      technical: isFr ? 'Traduction technique' : isAr ? 'ترجمة تقنية' : 'Technical translation',
      medical: isFr ? 'Traduction médicale' : isAr ? 'ترجمة طبية' : 'Medical translation',
      financial: isFr ? 'Traduction financière' : isAr ? 'ترجمة مالية' : 'Financial translation',
      commercial: isFr ? 'Traduction commerciale' : isAr ? 'ترجمة تجارية' : 'Commercial translation',
      marketing: isFr ? 'Traduction marketing' : isAr ? 'ترجمة تسويق' : 'Marketing translation',
      it: isFr ? 'Traduction informatique' : isAr ? 'ترجمة معلوماتية' : 'IT translation',
      scientific: isFr ? 'Traduction scientifique' : isAr ? 'ترجمة علمية' : 'Scientific translation',
      audiovisual: isFr ? 'Traduction audiovisuelle' : isAr ? 'ترجمة سمعية بصرية' : 'Audiovisual translation',
      tourism: isFr ? 'Traduction touristique' : isAr ? 'ترجمة سياحية' : 'Tourism translation',
      literary: isFr ? 'Traduction littéraire' : isAr ? 'ترجمة أدبية' : 'Literary translation',
      luxury: isFr ? 'Traduction dans le luxe' : isAr ? 'ترجمة الفخامة' : 'Luxury translation',
      website: isFr ? 'Traduction de site Internet' : isAr ? 'ترجمة مواقع' : 'Website translation',
      softwareLocalization: isFr ? 'Localisation de logiciels' : isAr ? 'توطين برمجيات' : 'Software localization',
      appLocalization: isFr ? 'Localisation d\'applications' : isAr ? 'توطين تطبيقات' : 'App localization',
      seo: isFr ? 'Traduction SEO' : isAr ? 'ترجمة SEO' : 'SEO translation',
    },
    interpretingTypes: {
      simultaneous: isFr ? 'Interprétation simultanée' : isAr ? 'ترجمة فورية متزامنة' : 'Simultaneous interpreting',
      consecutive: isFr ? 'Interprétation consécutive' : isAr ? 'ترجمة تتابعية' : 'Consecutive interpreting',
      liaison: isFr ? 'Interprétation de liaison' : isAr ? 'ترجمة مرافقة' : 'Liaison interpreting',
      judicial: isFr ? 'Interprétation judiciaire' : isAr ? 'ترجمة قضائية' : 'Judicial interpreting',
      medical: isFr ? 'Interprétation médicale' : isAr ? 'ترجمة طبية فورية' : 'Medical interpreting',
      commercial: isFr ? 'Interprétation commerciale' : isAr ? 'ترجمة تجارية فورية' : 'Commercial interpreting',
      phone: isFr ? 'Interprétation téléphonique' : isAr ? 'ترجمة هاتفية' : 'Telephone interpreting',
      video: isFr ? 'Interprétation en visioconférence' : isAr ? 'ترجمة عبر الفيديو' : 'Video conference interpreting',
    },

    // Step 3
    step3Title: isFr ? 'Langues' : isAr ? 'اللغات' : 'Languages',
    sourceLang: isFr ? 'Langue source' : isAr ? 'اللغة المصدر' : 'Source language',
    targetLang: isFr ? 'Langue cible' : isAr ? 'اللغة الهدف' : 'Target language',
    languages: L,

    // Step 4 — translation
    step4Title: isFr ? 'Informations sur le projet' : isAr ? 'معلومات المشروع' : 'Project details',
    documentType: isFr ? 'Type de document' : isAr ? 'نوع الوثيقة' : 'Document type',
    documentTypes: {
      civil: isFr ? 'Acte d\'état civil' : isAr ? 'عقد حالة مدنية' : 'Civil-status record',
      diploma: isFr ? 'Diplôme' : isAr ? 'شهادة' : 'Diploma',
      passport: isFr ? 'Passeport' : isAr ? 'جواز سفر' : 'Passport',
      idcard: isFr ? 'Carte d\'identité' : isAr ? 'بطاقة هوية' : 'ID card',
      driving: isFr ? 'Permis de conduire' : isAr ? 'رخصة قيادة' : 'Driving licence',
      contract: isFr ? 'Contrat' : isAr ? 'عقد' : 'Contract',
      judgment: isFr ? 'Jugement' : isAr ? 'حكم' : 'Judgment',
      notarial: isFr ? 'Acte notarié' : isAr ? 'عقد موثق' : 'Notarial deed',
      medicalReport: isFr ? 'Rapport médical' : isAr ? 'تقرير طبي' : 'Medical report',
      manual: isFr ? 'Manuel technique' : isAr ? 'دليل تقني' : 'Technical manual',
      catalogue: isFr ? 'Catalogue' : isAr ? 'كتالوج' : 'Catalogue',
      brochure: isFr ? 'Brochure' : isAr ? 'كتيب' : 'Brochure',
      website: isFr ? 'Site Internet' : isAr ? 'موقع إلكتروني' : 'Website',
      mobileApp: isFr ? 'Application mobile' : isAr ? 'تطبيق جوال' : 'Mobile app',
      softwareDoc: isFr ? 'Documentation logicielle' : isAr ? 'وثائق برمجية' : 'Software documentation',
      scientificArticle: isFr ? 'Article scientifique' : isAr ? 'مقال علمي' : 'Scientific article',
      cv: 'CV',
      letter: isFr ? 'Lettre' : isAr ? 'رسالة' : 'Letter',
      other: isFr ? 'Autre' : isAr ? 'آخر' : 'Other',
    },
    domain: isFr ? 'Domaine' : isAr ? 'المجال' : 'Domain',
    domains: {
      legal: isFr ? 'Juridique' : isAr ? 'قانوني' : 'Legal',
      medical: isFr ? 'Médical' : isAr ? 'طبي' : 'Medical',
      technical: isFr ? 'Technique' : isAr ? 'تقني' : 'Technical',
      commercial: isFr ? 'Commercial' : isAr ? 'تجاري' : 'Commercial',
      financial: isFr ? 'Financier' : isAr ? 'مالي' : 'Financial',
      marketing: isFr ? 'Marketing' : isAr ? 'تسويق' : 'Marketing',
      it: isFr ? 'Informatique' : isAr ? 'معلوماتي' : 'IT',
      scientific: isFr ? 'Scientifique' : isAr ? 'علمي' : 'Scientific',
      tourism: isFr ? 'Tourisme' : isAr ? 'سياحة' : 'Tourism',
      luxury: isFr ? 'Luxe' : isAr ? 'فخامة' : 'Luxury',
      education: isFr ? 'Éducation' : isAr ? 'تعليم' : 'Education',
      industry: isFr ? 'Industrie' : isAr ? 'صناعة' : 'Industry',
      other: isFr ? 'Autre' : isAr ? 'آخر' : 'Other',
    },
    volume: isFr ? 'Volume' : isAr ? 'الحجم' : 'Volume',
    pages: isFr ? 'Nombre de pages' : isAr ? 'عدد الصفحات' : 'Number of pages',
    words: isFr ? 'Nombre de mots' : isAr ? 'عدد الكلمات' : 'Number of words',
    fileCount: isFr ? 'Nombre de fichiers' : isAr ? 'عدد الملفات' : 'Number of files',
    docFormat: isFr ? 'Format du document' : isAr ? 'صيغة الوثيقة' : 'Document format',
    formats: {
      pdf: 'PDF',
      word: 'Word',
      excel: 'Excel',
      ppt: 'PowerPoint',
      image: isFr ? 'Image' : isAr ? 'صورة' : 'Image',
      indesign: 'InDesign',
      autocad: 'AutoCAD',
      html: 'HTML',
      xml: 'XML',
      other: isFr ? 'Autre' : isAr ? 'آخر' : 'Other',
    },
    upload: isFr ? 'Téléversement des fichiers' : isAr ? 'رفع الملفات' : 'File upload',
    options: isFr ? 'Options supplémentaires' : isAr ? 'خيارات إضافية' : 'Additional options',
    optionProofreading: isFr ? 'Relecture linguistique' : isAr ? 'مراجعة لغوية' : 'Linguistic proofreading',
    optionLayout: isFr ? 'Mise en page identique au document original' : isAr ? 'تنسيق مطابق للأصل' : 'Layout identical to original',
    optionCertified: isFr ? 'Traduction certifiée' : isAr ? 'ترجمة مصادق عليها' : 'Certified translation',
    optionSworn: isFr ? 'Traduction assermentée' : isAr ? 'ترجمة محلّفة' : 'Sworn translation',
    optionConfidential: isFr ? 'Confidentialité renforcée' : isAr ? 'سرية معززة' : 'Enhanced confidentiality',
    deadline: isFr ? 'Délai souhaité' : isAr ? 'الأجل المطلوب' : 'Desired deadline',
    deadlineStandard: isFr ? 'Standard' : isAr ? 'عادي' : 'Standard',
    deadlinePriority: isFr ? 'Prioritaire' : isAr ? 'أولوية' : 'Priority',
    deadlineUrgent: isFr ? 'Urgent' : isAr ? 'عاجل' : 'Urgent',
    deadlineDate: isFr ? 'Date précise' : isAr ? 'تاريخ محدد' : 'Specific date',
    preciseDate: isFr ? 'Date' : isAr ? 'التاريخ' : 'Date',

    // Step 4 — interpreting
    missionType: isFr ? 'Type de mission' : isAr ? 'نوع المهمة' : 'Mission type',
    missionTypes: {
      meeting: isFr ? 'Réunion' : isAr ? 'اجتماع' : 'Meeting',
      conference: isFr ? 'Conférence' : isAr ? 'مؤتمر' : 'Conference',
      court: isFr ? 'Tribunal' : isAr ? 'محكمة' : 'Court',
      medical: isFr ? 'Rendez-vous médical' : isAr ? 'موعد طبي' : 'Medical appointment',
      training: isFr ? 'Formation' : isAr ? 'تدريب' : 'Training',
      negotiation: isFr ? 'Négociation commerciale' : isAr ? 'تفاوض تجاري' : 'Business negotiation',
      event: isFr ? 'Événement' : isAr ? 'فعالية' : 'Event',
      fair: isFr ? 'Salon professionnel' : isAr ? 'معرض مهني' : 'Trade fair',
      other: isFr ? 'Autre' : isAr ? 'آخر' : 'Other',
    },
    missionDate: isFr ? 'Date de la mission' : isAr ? 'تاريخ المهمة' : 'Mission date',
    startTime: isFr ? 'Heure de début' : isAr ? 'ساعة البداية' : 'Start time',
    endTime: isFr ? 'Heure de fin' : isAr ? 'ساعة النهاية' : 'End time',
    duration: isFr ? 'Durée estimée' : isAr ? 'المدة التقديرية' : 'Estimated duration',
    location: isFr ? 'Lieu' : isAr ? 'المكان' : 'Location',
    address: isFr ? 'Adresse' : isAr ? 'العنوان' : 'Address',
    mode: isFr ? 'Mode' : isAr ? 'النمط' : 'Mode',
    modeOnsite: isFr ? 'Présentiel' : isAr ? 'حضوري' : 'On-site',
    modeRemote: isFr ? 'À distance' : isAr ? 'عن بُعد' : 'Remote',
    platform: isFr ? 'Plateforme' : isAr ? 'المنصة' : 'Platform',
    platforms: {
      zoom: 'Zoom',
      teams: 'Microsoft Teams',
      meet: 'Google Meet',
      webex: 'Webex',
      other: isFr ? 'Autre' : isAr ? 'آخر' : 'Other',
    },
    participants: isFr ? 'Nombre de participants' : isAr ? 'عدد المشاركين' : 'Number of participants',
    equipment: isFr ? 'Besoin en matériel' : isAr ? 'احتياج المعدات' : 'Equipment needs',
    equipBooth: isFr ? 'Cabine d\'interprétation' : isAr ? 'كابينة ترجمة' : 'Interpreting booth',
    equipHeadsets: isFr ? 'Casques' : isAr ? 'سماعات' : 'Headsets',
    equipMics: isFr ? 'Microphones' : isAr ? 'ميكروفونات' : 'Microphones',
    equipNone: isFr ? 'Aucun matériel requis' : isAr ? 'لا معدات مطلوبة' : 'No equipment required',

    // Step 5
    step5Title: isFr ? 'Livraison' : isAr ? 'التسليم' : 'Delivery',
    deliveryMode: isFr ? 'Mode de livraison souhaité' : isAr ? 'طريقة التسليم المطلوبة' : 'Preferred delivery method',
    deliveryModes: {
      email: 'E-mail',
      download: isFr ? 'Téléchargement sécurisé' : isAr ? 'تحميل آمن' : 'Secure download',
      post: isFr ? 'Courrier postal' : isAr ? 'بريد' : 'Postal mail',
      pickup: isFr ? 'Retrait sur place' : isAr ? 'استلام حضوري' : 'On-site pickup',
    },

    // Step 6
    step6Title: isFr ? 'Commentaires' : isAr ? 'ملاحظات' : 'Comments',
    instructions: isFr ? 'Instructions particulières' : isAr ? 'تعليمات خاصة' : 'Special instructions',
    instructionsPlaceholder: isFr
      ? 'Contraintes terminologiques, glossaire à respecter, mise en page spécifique, exigences du client…'
      : isAr
        ? 'قيود مصطلحية، مسرد مطلوب، تنسيق خاص، متطلبات العميل…'
        : 'Terminology constraints, glossary to follow, specific layout, client requirements…',

    // Step 7
    step7Title: isFr ? 'Validation' : isAr ? 'التأكيد' : 'Confirmation',
    attestAccurate: isFr
      ? 'J\'atteste que les informations fournies sont exactes.'
      : isAr
        ? 'أقر بأن المعلومات المقدمة صحيحة.'
        : 'I confirm that the information provided is accurate.',
    acceptPrivacy: isFr
      ? 'J\'accepte la politique de confidentialité.'
      : isAr
        ? 'أوافق على سياسة الخصوصية.'
        : 'I accept the privacy policy.',
    acceptTerms: isFr
      ? 'J\'accepte les conditions générales.'
      : isAr
        ? 'أوافق على الشروط العامة.'
        : 'I accept the terms and conditions.',
    summary: isFr ? 'Récapitulatif' : isAr ? 'الملخص' : 'Summary',
  };
}

export const quoteWizardFr = build('fr');
export const quoteWizardAr = build('ar');
export const quoteWizardEn = build('en');

export const TRANSLATION_SERVICE_GROUPS = [
  {
    id: 'official',
    keys: ['sworn', 'certified'],
  },
  {
    id: 'specialized',
    keys: [
      'legal',
      'technical',
      'medical',
      'financial',
      'commercial',
      'marketing',
      'it',
      'scientific',
      'audiovisual',
      'tourism',
      'literary',
      'luxury',
    ],
  },
  {
    id: 'digital',
    keys: ['website', 'softwareLocalization', 'appLocalization', 'seo'],
  },
];

export const INTERPRETING_TYPE_KEYS = [
  'simultaneous',
  'consecutive',
  'liaison',
  'judicial',
  'medical',
  'commercial',
  'phone',
  'video',
];

export function createQuoteRequestId() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const rand = String(Math.floor(Math.random() * 9000) + 1000);
  return `DEV-${y}${m}${day}-${rand}`;
}

export function saveQuoteRequestLocal(payload) {
  const key = 'tarjemlek_quote_requests';
  const existing = JSON.parse(localStorage.getItem(key) || '[]');
  const now = new Date().toISOString();
  const record = {
    ...payload,
    status: 'pending',
    createdAt: now,
    updatedAt: now,
    assignedTo: null,
    proposedPrice: null,
    currency: 'TND',
    estimatedDeadline: null,
    discount: null,
    internalNotes: '',
  };
  existing.unshift(record);
  localStorage.setItem(key, JSON.stringify(existing.slice(0, 200)));
  return record;
}

function getQuoteApiUrl() {
  if (process.env.REACT_APP_QUOTE_API_URL) {
    return process.env.REACT_APP_QUOTE_API_URL;
  }

  const projectPrefix = window.location.pathname.includes('/tarjemliPlateforme/')
    ? '/tarjemliPlateforme'
    : window.location.port === '3000'
      ? '/tarjemliPlateforme'
      : '';

  return `${window.location.protocol}//${window.location.hostname}${projectPrefix}/api/quotes.php`;
}

export async function submitQuoteRequest(payload, files = []) {
  const body = new FormData();
  body.append('payload', JSON.stringify(payload));
  files.forEach((file) => body.append('files[]', file, file.name));

  const response = await fetch(getQuoteApiUrl(), {
    method: 'POST',
    body,
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.ok) {
    throw new Error(result.error || `Quote request failed (${response.status})`);
  }

  return result.request;
}
